// Importing components
import { FormElems, ConditionalComponent, Alert, FakeLoader } from 'components';
import {
    CHARGEBACK_STATUS_ENUM,
    MAX_25MB,
    POPUP_ENUM,
} from '../../utils/constants/commonValues';
import { validators } from '../../utils/validators';

// Importing Libraries
import {
    UPDATE_STATUS_OPTIONS,
    UPDATE_STATUS_OPTIONS_NEW_LEVEL,
} from './constant';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

// Importing constants

import './updateChargeBackStatusForm.scss';

const UpdateChargeBackStatusForm = ({
    handleSubmit,
    onClose,
    onSubmit,
    chargebackAgentAction,
    currentChargebackStatus,
    chargebackMetaData,
    formData,
}) => {
    const handleUpdateStatusFormSubmit = values => {
        if (chargebackMetaData?.currentChargebackLevel === 'L3') {
            values.chargebackLevel = 'L3';
        }

        onSubmit(POPUP_ENUM.UPDATE_FORM, values);
    };

    const [fileList, setFileList] = useState([]);

    const getLevelOptions = currentChargebackLevel => {
        switch (currentChargebackLevel) {
            case 'L1':
                return [
                    { label: 'L1', value: 'L1' },
                    { label: 'L2', value: 'L2' },
                ];
            case 'L2':
                return [
                    { label: 'L2', value: 'L2' },
                    { label: 'L3', value: 'L3' },
                ];
            case 'L3':
                return [];
            default:
                return [];
        }
    };

    return (
        <form
            className="update-chargeback-status-form"
            onSubmit={handleSubmit(handleUpdateStatusFormSubmit)}
        >
            <ConditionalComponent isVisible={chargebackAgentAction?.isLoading}>
                <FakeLoader withMask />
            </ConditionalComponent>
            <ConditionalComponent
                isVisible={
                    currentChargebackStatus ===
                        CHARGEBACK_STATUS_ENUM.SUBMITTED_TO_BANK.value &&
                    chargebackMetaData?.currentChargebackLevel !== 'L3'
                }
            >
                <div className="form-field ">
                    <p className="label">Chargeback Level</p>
                    <Field
                        name="chargebackLevel"
                        labelField="label"
                        valueField="value"
                        label="Select Level"
                        data={
                            getLevelOptions(
                                chargebackMetaData?.currentChargebackLevel
                            ) || []
                        }
                        component={FormElems.Select}
                    />
                </div>
            </ConditionalComponent>
            <div className="form-field ">
                <p className="label">Chargeback Status</p>
                <Field
                    name="status"
                    component={FormElems.Radio}
                    labelField="name"
                    valueField="value"
                    wrapperClass="wrap-checkbox"
                    options={
                        chargebackMetaData?.currentChargebackLevel === 'L3' &&
                        currentChargebackStatus ===
                            CHARGEBACK_STATUS_ENUM.SUBMITTED_TO_BANK.value
                            ? UPDATE_STATUS_OPTIONS.CLOSURE_OPTIONS
                            : formData?.values?.chargebackLevel !==
                              chargebackMetaData?.currentChargebackLevel
                            ? UPDATE_STATUS_OPTIONS_NEW_LEVEL[
                                  currentChargebackStatus
                              ]
                            : UPDATE_STATUS_OPTIONS[currentChargebackStatus] ||
                              []
                    }
                />
            </div>
            <div className="form-field ">
                <Field
                    wrapperClass="comment-input"
                    name="remarks"
                    type="textarea"
                    isDisabled={false}
                    component={FormElems.TextArea}
                    placeholder="Remarks"
                />
            </div>
            <ConditionalComponent
                isVisible={
                    currentChargebackStatus ===
                    CHARGEBACK_STATUS_ENUM.SUBMITTED_TO_BANK.value
                }
            >
                <div className="form-field">
                    <p className="label">Additional Document(s)</p>
                    <Field
                        name="files"
                        type="file"
                        layout="vertical"
                        onFileListChange={files => setFileList(files)}
                        fileList={fileList}
                        accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .jpeg, .png, .gif, .zip, .rar, .7zip"
                        subtitle={'4 files max . Maximum file size 25MB.'}
                        component={FormElems.MultiUpload}
                        maxSize={MAX_25MB}
                    />
                </div>
            </ConditionalComponent>
            <ConditionalComponent
                isVisible={
                    chargebackAgentAction &&
                    chargebackAgentAction?.error &&
                    chargebackAgentAction?.error?.errorMessage
                }
            >
                <Alert customClass="error-msg">
                    {chargebackAgentAction?.error?.errorMessage}
                </Alert>
            </ConditionalComponent>
            <div className="form-section-actions">
                <FormElems.Button
                    buttonType="secondary"
                    id="back-btn"
                    text="Cancel"
                    type="button"
                    handleClick={onClose}
                    customClass="back-btn"
                />
                <FormElems.Button
                    id="next-btn"
                    buttonType="primary"
                    text="Submit"
                />
            </div>
        </form>
    );
};

const mapStateToProps = ({ form }) => ({
    formData: form['update-chargeback-status-form'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({}, dispatch),
});

export default compose(
    reduxForm({
        form: 'update-chargeback-status-form',
        enableReinitialize: true,
        validate: ({ status }) => {
            const { REQUIRED } = validators;

            const errors = {};

            if (REQUIRED(status)) {
                errors.status = `Please select status`;
            }

            return errors;
        },
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(UpdateChargeBackStatusForm);

// PropType validation for UpdateChargeBackStatusForm component
UpdateChargeBackStatusForm.propTypes = {
    formData: PropTypes.object,
    chargebackAgentAction: PropTypes.object,
    onClose: PropTypes.func,
    currentChargebackStatus: PropTypes.string,
    onSubmit: PropTypes.func,
    handleSubmit: PropTypes.func,
};
